import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/AuthSlice";
import Axios from "../config/AxiosConfig";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import "react-toastify/dist/ReactToastify.css";
import logo from "../assets/image/Restaurant Icon.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await Axios.post("super-admin/login", { email, password });

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.superAdmin));
      dispatch(loginSuccess(response.data.superAdmin));
      navigate("/dashboard");
      setLoading(false);
      toast.success("Login successful!", { position: "top-right" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Invalid credentials!", {
        position: "top-right",
      });
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-left">
        <img src={logo} alt="App Logo" className="auth-logo" />
        <h2>Welcome to Super Admin Panel</h2>
        <p>Track restaurants & bookings easily.</p>
      </div>
      <div className="auth-right">
        <div className="auth-card">
          <h3 className="text-center">Login</h3>
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeSlash /> : <Eye />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-success w-100" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span> Logging in...
                </>
              ) : (
                "Login"
              )}
            </button>
            <div className="text-center mt-3">
              <Link to="/forgot-password" className="auth-link">
                Forgot Password?
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
